import { Typography } from "antd";
import { useIntl } from "react-intl";
import { transactionStatusColor } from "@lib/helpers/ColorHelper";
import { TransactionProxyStatus } from "@lib/types/Transaction";
import styled from "styled-components";

type Props = {
  status: TransactionProxyStatus;
  size?: "small" | "medium";
};

const StyledTypography = styled(Typography.Text)<{ size?: "small" | "medium" }>`
  &.ant-typography {
    background-color: ${({ color }) => color};
    padding: 2px 4px;
    border-radius: 4px;
    color: ${({ theme }) => theme.palette.white}!important;
    font-size: ${({ size }) => (size === "small" ? "10px" : "12px")};
  }
`;

export default function PaymentHistoryStatus(props: Props) {
  const { status, size = "medium" } = props;
  const { messages } = useIntl();

  return (
    <StyledTypography
      ellipsis
      color={transactionStatusColor(status)}
      size={size}
    >
      {(messages["enums.transactionStatus"][status] as string) ||
        status ||
        " N/A "}
    </StyledTypography>
  );
}
